"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetRegulationItem = void 0;
class AssetRegulation {
    constructor({ text, items }) {
        this.toJSON = () => ({
            text: this.text,
            items: this.items,
        });
        this.text = text;
        this.items = items;
    }
    static fromJSON(json) {
        const { text, items } = Object.assign({}, json);
        if (typeof text !== 'string')
            throw new Error('.text must be a string');
        if (!Array.isArray(items))
            throw new Error('.items must be an array');
        return new AssetRegulation({ text, items: items.map(item => AssetRegulationItem.fromJSON(item)) });
    }
}
// FIXME: 別ファイルに切り出すか inner classにした方が良い
class AssetRegulationItem {
    constructor({ type, expectedAmount }) {
        this.toJSON = () => ({
            type: this.type,
            expectedAmount: this.expectedAmount,
        });
        this.type = type;
        this.expectedAmount = expectedAmount;
    }
    static fromJSON(json) {
        const { type, expectedAmount } = Object.assign({}, json);
        if (typeof type !== 'string')
            throw new Error('.type must be a string');
        if (typeof expectedAmount !== 'number')
            throw new Error('.expectedAmount must be a number');
        return new AssetRegulationItem({ type: type, expectedAmount });
    }
}
exports.AssetRegulationItem = AssetRegulationItem;
exports.default = AssetRegulation;
